import { Task } from '../types';

// `dueDate` is the legacy start field. New schedules keep the start alongside
// the end in one object, while this fallback preserves existing local data.
export const getTaskStartDateValue = (task: Task) => task.schedule?.startDate || task.dueDate;

export const getTaskStartDate = (task: Task) => {
    const value = getTaskStartDateValue(task);
    return value ? new Date(value) : undefined;
};

export const isStartSchedule = (schedule: Task['schedule'] | undefined) => (
    schedule?.kind === 'start' || (!schedule?.kind && Boolean(schedule?.startDate) && !schedule?.endDate)
);

export const withScheduleStartDate = (schedule: Task['schedule'] | undefined, startDate?: string) => {
    if (!schedule) return undefined;
    if (schedule.kind === 'deadline') {
        return { ...schedule, endDate: startDate || schedule.endDate };
    }
    return { ...schedule, startDate: startDate || schedule.startDate };
};
